/*
 * Copyright (c) Nexign, JSC, 2022-2024.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Ilya Baranchikov
 * @version 1.28.0
 * @since 1.20.0
 */

import { createSelector } from 'reselect';

import { EInquiryStates } from './inquiryStateTypes';
import { inquiryStateApi } from './store';

export const inquiryStateSelector = inquiryStateApi.endpoints.getInquiryState.select();

export const inquiryStateIsComplete = createSelector(
    inquiryStateSelector,
    ({ data }) => data?.currentState === EInquiryStates.IS_DONE,
);

export const inquiryOtherStateSelector = inquiryStateApi.endpoints.getOtherInquiryState.select();

export const inquiryOtherStateIsComplete = createSelector(
    inquiryOtherStateSelector,
    ({ data }) => data?.currentState === EInquiryStates.IS_DONE,
);
